const GROUP_BY_TYPES = ['shift', 'team'] as const;

export type GroupByType = (typeof GROUP_BY_TYPES)[number];
export type GroupByTypesMap = { [K in GroupByType]: K };

export const GROUP_BY_TYPES_MAP = {
  shift: 'shift',
  team: 'team',
} satisfies GroupByTypesMap;

export const FILTER_GROUP = {
  [GROUP_BY_TYPES_MAP.shift]: {
    available: GROUP_BY_TYPES_MAP.shift,
    selected: 'selectedShift',
  },
  [GROUP_BY_TYPES_MAP.team]: {
    available: GROUP_BY_TYPES_MAP.team,
    selected: 'selectedTeam',
  },
} as const;

export type ReportProdAnalyzeGraphPoint = {
  date: string;

  // The `string` is required to match the record signature
  [serieId: string]: number | string;
};

export type SerieMetadata = {
  id: string;
  name: string;
};
